/* global React, useState, Icon, Button, Input, toast, window */
// ============================================================
// SIGNERINGSANSVARLIGE — styre og daglig leder i aarsregnskapet
// ============================================================
// Panelet ligger i dokumentsteget fordi det er der signeringen skjer. Navn og
// roller hentes fra Enhetsregisteret; e-post finnes ikke i noe register og maa
// fylles inn her. Reglene for hvem som signerer hva ligger i
// `services/companyRoles.jsx`, ikke i denne komponenten.

function AnnualSignerPanel({ documentKey = 'pdf', people = [], onSave, onRefresh, disabled = false }) {
  const roles = window.PlummeCompanyRoles;
  const t = (key, fallback, vars) => (window.PlummeI18n?.t ? window.PlummeI18n.t(key, fallback, vars) : fallback);
  const [loading, setLoading] = useState(false);
  const [drafts, setDrafts] = useState({});
  if (!roles) return null;

  const signers = roles.signersForDocument(people, documentKey);
  const missing = roles.signersMissingEmail(people, documentKey);
  const emailFor = (person) => (drafts[person.id] === undefined ? person.email : drafts[person.id]);

  const refresh = async () => {
    if (!onRefresh) return;
    setLoading(true);
    try {
      await onRefresh();
      setDrafts({});
      toast(t('clo.rolesFetched', 'Roller hentet fra Enhetsregisteret'), 'success');
    } catch (error) {
      toast(error?.message || t('svc.registryRolesFailed', 'Kunne ikke hente roller fra Enhetsregisteret.'), 'error');
    } finally {
      setLoading(false);
    }
  };

  const saveEmail = (person) => {
    const email = String(emailFor(person) || '').trim();
    if (email === person.email || !onSave) return;
    void onSave(people.map((entry) => entry.id === person.id ? { ...entry, email } : entry));
  };

  return <div className="cl-signers">
    <div className="cl-signers-head">
      <div>
        <h4 data-help={t('helpTopics.signing.body')} data-help-title={t('helpTopics.signing.title')}>{t('clo.signersTitle', 'Hvem skal signere')}</h4>
        <div className="t-sm muted">{t('clo.signersHelp', 'Navn og roller kommer fra Enhetsregisteret. E-post finnes ikke der, så den må du fylle inn selv.')}</div>
      </div>
      <Button size="sm" variant="secondary" icon="refresh" disabled={disabled || loading} onClick={refresh}>
        {loading ? t('clo.rolesFetching', 'Henter…') : t('clo.rolesFetch', 'Hent fra Enhetsregisteret')}
      </Button>
    </div>

    {!signers.length
      ? <p className="t-sm muted cl-signers-empty">{t('clo.signersEmpty', 'Ingen roller er registrert ennå. Hent dem fra Enhetsregisteret for å komme i gang.')}</p>
      : <div className="cl-signer-list">
        {signers.map((person) => <div key={person.id} className={'cl-signer-row' + (person.email ? '' : ' missing')}>
          <div className="cl-signer-who">
            <strong>{person.name}</strong>
            <span className="t-sm muted">{person.roles.map((role) => roles.roleLabel(role)).join(' · ')}</span>
          </div>
          <Input
            type="email"
            inputMode="email"
            placeholder={t('clo.signerEmailPh', 'E-post for signering')}
            value={emailFor(person)}
            disabled={disabled}
            onChange={(event) => setDrafts((current) => ({ ...current, [person.id]: event.target.value }))}
            onBlur={() => saveEmail(person)}
          />
        </div>)}
      </div>}

    {missing.length ? <div className="cl-signers-warn">
      <Icon name="info" size={15} />
      <span>{t('clo.signersMissingEmail', 'Signeringen kan ikke sendes ut før alle har e-post: {names}', { names: missing.map((person) => person.name).join(', ') })}</span>
    </div> : null}
  </div>;
}

Object.assign(window, { AnnualSignerPanel });
